import React from 'react';

import './print.css';
import requireAuth from '~components/hocs/requireAuth';
import { PrintableExportShell } from '~components/PrintableLayout';
import { DiagnosticsReportView, hasAiInsightsAccess } from '~features/ai-insights';

function DiagnosticsReportExport() {
  return (
    <PrintableExportShell>
      <DiagnosticsReportView print />
    </PrintableExportShell>
  );
}

export default requireAuth(DiagnosticsReportExport, hasAiInsightsAccess);
